/** `/paginas` sin página: un punto de partida con lo último tocado, o la primera página. */
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { api } from '../api'
import { usePortal } from '../contexto'
import { hace } from '../textos'
import { IconoDePagina } from './Arbol'
import { useEspacio } from './contexto'
import { PLANTILLAS } from './plantillas'
import type { Resultado } from './tipos'

export default function Inicio() {
  const { servidor, puedo } = usePortal()
  const { rutaPaginas, crear, cargado, arbol } = useEspacio()
  const [recientes, setRecientes] = useState<Resultado[]>([])
  const puedeEditar = puedo('editar_paginas')

  useEffect(() => {
    api.get<Resultado[]>(`${rutaPaginas}/recientes`).then(setRecientes).catch(() => undefined)
  }, [rutaPaginas])

  const nueva = (id: string) => {
    const t = PLANTILLAS.find((x) => x.id === id)
    if (t) void crear({ title: t.titulo, icon: t.icono, content: t.bloques })
  }

  return (
    <div className="pagina pagina--estrecha inicio">
      <h1 className="inicio__titulo">Páginas</h1>
      <p className="inicio__texto">
        Documentación, normativas y notas del equipo. Escribe <kbd>/</kbd> dentro de una página
        para insertar títulos, listas, tablas o código, y pulsa <kbd>Ctrl</kbd> <kbd>K</kbd> para
        buscar en cualquier momento.
      </p>

      {cargado && arbol.length === 0 && (
        <div className="inicio__vacio">
          <div className="inicio__emoji">📄</div>
          <h2>Todavía no hay ninguna página</h2>
          {puedeEditar ? (
            <>
              <p>Empieza en blanco o con una plantilla.</p>
              <div className="fila-botones" style={{ justifyContent: 'center' }}>
                <button className="boton boton--principal" onClick={() => void crear()}>
                  Crear la primera página
                </button>
                <button className="boton" onClick={() => void crear({ kind: 'database', title: 'Base de datos' })}>
                  Crear una base de datos
                </button>
              </div>
            </>
          ) : (
            <p>Cuando alguien del equipo cree una, aparecerá aquí.</p>
          )}
        </div>
      )}

      {recientes.length > 0 && (
        <>
          <h3 className="inicio__seccion">Recientes</h3>
          <div className="inicio__rejilla">
            {recientes.map((r) => (
              <Link key={r.id} to={`/${servidor.id}/paginas/${r.id}`} className="inicio__tarjeta">
                <IconoDePagina icono={r.icon} tam={26} />
                <strong>{r.title || 'Sin título'}</strong>
                <small>{r.fragmento || 'Página vacía'}</small>
                <span className="inicio__cuando">{hace(r.updated_at)}</span>
              </Link>
            ))}
          </div>
        </>
      )}

      {puedeEditar && (
        <>
          <h3 className="inicio__seccion">Plantillas</h3>
          <div className="inicio__rejilla">
            <button className="inicio__tarjeta inicio__tarjeta--plantilla"
                    onClick={() => void crear({ kind: 'database', title: 'Base de datos' })}>
              <span className="inicio__emoji inicio__emoji--chico">▦</span>
              <strong>Base de datos</strong>
              <small>Tabla, tablero y galería con propiedades y filtros</small>
            </button>
            {PLANTILLAS.map((t) => (
              <button key={t.id} className="inicio__tarjeta inicio__tarjeta--plantilla"
                      onClick={() => nueva(t.id)}>
                <span className="inicio__emoji inicio__emoji--chico">{t.icono}</span>
                <strong>{t.nombre}</strong>
                <small>{t.descripcion}</small>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
